/**
 * @private
 */
export const StorageProvider = {
  Memory: 'Memory',
  WebSQL: 'WebSQL',
  IndexedDB: 'IndexedDB',
  LocalStorage: 'LocalStorage',
  SessionStorage: 'SessionStorage',
  SQLite: 'SQLite'
};



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/repositories/storage-provider.js